import styled from 'styled-components'
import { Box } from 'rebass'
import LoadingSpinner from '../../../assets/LoadingSpinner'

export const Feedback = styled(Box)`
  text-align: left;
  color: ${(props) => props.theme.colors.grey};
  position: relative;
  line-height: 1;
  padding: 8px 25px;
  &:first-child {
    margin-top: 15px;
  }
  &:last-child {
    margin-bottom: 20px;
  }
`

export const Loading = styled(Feedback)`
  color: ${(props) => props.theme.colors.blue};
  font-style: italic;
  text-align: left;
  padding-top: 15px;
  margin-left: 15px;
  &:last-child {
    padding-top: 25px;
    margin-bottom: 0;
  }
  &:first-child {
    padding-top: 15px;
    margin-bottom: 0;
  }
`

export const ErrorFeedback = styled(Feedback)`
  color: ${(props) => props.theme.colors.orange};
`

export const Spinner = styled(LoadingSpinner)`
  position: relative;
  z-index: 1;
  margin: -15px auto;
  transform-origin: 0 0;
  transform: scale(0.52) translateX(-50%);
  g {
    fill: ${(props) => props.theme.colors.blue};
  }
`
